import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";

const routes: Routes = [
  {
    path: "dashboard",
    loadChildren: () =>
      import("src/app/modules/device-management/device-management.module").then(
        (m) => m.DeviceManagementModule
      ),
  },
  {
    path: "asset-management",
    loadChildren: () =>
      import("src/app/modules/asset-management/asset-management.module").then(
        (m) => m.AssetManagementModule
      ),
  },
  {
    path: "application",
    loadChildren: () =>
      import("src/app/modules/application/application.module").then(
        (m) => m.ApplicationModule
      ),
  },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
